module.exports = __webpack_public_path__ + "v4assets/gigamon-logo.abcbeb65b1255b98ca3638b7d14060b8.png";